var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3550({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9453,
    cy: 21.8071,
    rx: 22,
    ry: 21.8071,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9453,
    cy: 19.8772,
    rx: 17.7168,
    ry: 17.5615,
    fill: "#463CB4",
    fillOpacity: 0.25
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.0419,
    cy: 15.5348,
    rx: 8.27434,
    ry: 8.2018,
    fill: "#463CB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31836 37.8243L9.51637 37.9134C18.12 41.7843 27.9692 41.787 36.575 37.9208C36.575 30.4068 30.4122 24.3154 22.8982 24.3154C15.4374 24.3154 9.31836 30.3636 9.31836 37.8243Z",
    fill: "#463CB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3550);
export default __webpack_public_path__ + "static/media/Group 3550.6589753c52cd47b6ed3fd19dd63343e7.svg";
export { ForwardRef as ReactComponent };